import { ProfitabilityEstimateDTOFxRates } from 'api';
import { Box, Typography } from 'ui';

export const CurrencyRates = ({ fxRates }: { fxRates: ProfitabilityEstimateDTOFxRates }) => {
  return (
    fxRates && (
      <>
        <Typography variant="h5" paddingY={2}>
          Rates
        </Typography>
        {Object.entries(fxRates).map(([base, quoteRates]) => (
          <div key={base}>
            {Object.entries(quoteRates).map(([quote, rate]) => (
              <Box component="p" key={`${base}-${quote}`}>
                {base}/{quote} = {rate}
              </Box>
            ))}
          </div>
        ))}
      </>
    )
  );
};
